<template>
  <el-dialog
    :title="displayText.title"
    :visible="true"
    :close-on-click-modal="false"
    @close="$emit('close')"
  >
    <TimeRangeSetting />
    <hr class="my-[32px]">
    <DisplaySetting :length="length" :storage-key="storageKey" :extra-content-options="extraContentOptions" />
    <div>
      <BaseElButton plain @click="$emit('close')">{{ displayText.btn.cancel }}</BaseElButton>
      <BaseElButton type="primary" @click="onConfirm">
        {{ displayText.btn.confirm }}
      </BaseElButton>
    </div>
  </el-dialog>
</template>

<script>
import { defineComponent, computed } from 'vue'
import { useStorage } from '@vueuse/core'
import TimeRangeSetting from './TimeRangeSetting.vue'
import DisplaySetting from './DisplaySetting.vue'
import { t } from '@/plugins/i18n/i18n'

export default defineComponent({
  name: 'DisplaySettingsDialog',
  components: { TimeRangeSetting, DisplaySetting },
  props: {
    length: {
      type: Number,
      default: 0,
    },
    storageKey: {
      type: String,
      default: 'dailyViewSettings',
    },
    extraContentOptions: {
      type: Array,
      default: () => [],
    },
  },
  setup (props, { emit }) {
    const formData = useStorage(props.storageKey, { start: '00:00', end: '24:00' })

    const displayText = computed(() => {
      const data = {
        title: t('dailyView.displaySettingsTitle'),
        btn: {
          cancel: t('common.button.cancel.text'),
          confirm: t('common.button.confirm2.text'),
        },
      }
      return data
    })
    const onConfirm = () => {
      if (!formData.value.end) {
        window.$message.error(t('dailyView.dialog.selectEndTime'))
        return
      }
      emit('confirm')
    }

    return {
      onConfirm,
      displayText,
    }
  },
})
</script>

<style scoped lang="postcss">

</style>
